import { ImageWithFallback } from '@/components/image-with-fallback';

import { IMAGE_HEIGHT, IMAGE_WIDTH } from './constants';
import styles from './styles.module.scss';
import type { Component } from './types';

export const Item: Component = ({
  relatedItem,
}) => (
  <a
    href={`https://www.mycarforum.com/index.php?app=marketplace&controller=info&id=${relatedItem.id}`}>
    <div className={styles.containerRoot}>
      <ImageWithFallback
        alt="item image"
        className={styles.itemImage}
        height={IMAGE_HEIGHT}
        src={`https://www.mycarforum.com/uploads/sgcarstore/data/1/thumbs/${relatedItem.image}`}
        width={IMAGE_WIDTH} />
      <div className={styles.textItemTitle}>
        {relatedItem.title}
      </div>
    </div>
  </a>
);
